"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
exports.Loading = function (_a) {
    var color = _a.color, duration = _a.duration;
    var borderColor = color ? color : '#fff';
    var animationDuration = duration ? duration : '.8';
    return (React.createElement(styledLayout_1.StyledLayout, { className: "ty-loading" },
        React.createElement("div", { style: {
                borderColor: borderColor + " " + borderColor + " " + borderColor + " transparent",
                animationDuration: animationDuration + "s"
            } })));
};
